module.exports = __webpack_public_path__ + "img/file-earmark-zip.73fec861.svg";